import { useResponsive } from '@shared/utils/hooks/useResponsive';
import { useMemo } from 'react';
import { CAROUSEL_BREAKPOINTS } from '@apps/registry/common/components/Catalog/Catalog.constants';

export const usePeekSize = ({ enablePeek }: { enablePeek?: boolean }) => {
  const [paddingX] = useResponsive(
    {
      values: {
        [CAROUSEL_BREAKPOINTS[0]]: 24,
        [CAROUSEL_BREAKPOINTS[1]]: 24,
        [CAROUSEL_BREAKPOINTS[2]]: 40,
        [CAROUSEL_BREAKPOINTS[3]]: 64,
        [CAROUSEL_BREAKPOINTS[4]]: 88,
      },
    },
    88,
  );

  const peekSize = useMemo(() => {
    return enablePeek ? paddingX : 0;
  }, [enablePeek, paddingX]);

  return {
    peekSize,
  };
};
